import { j as s } from "./index.es3.js";
import a from "react";
import i from "./index.es4.js";
import l from "./index.es5.js";
import "./index.es6.js";
import "./index.es7.js";
import d from "./index.es8.js";
import { convertToBlockTags as f } from "./index.es9.js";
const p = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5"
}, c = (e, t) => {
  const r = d(e, t);
  if (r)
    return r;
}, u = (e) => {
  if (a.isValidElement(e))
    return e;
  const r = f(e);
  return l(r, { transform: c });
}, E = ({ id: e, type: t = "3", text: r, styleClassNames: o }) => {
  const m = i({
    "font-sansCondensed leading-tight": !0,
    "font-normal pb-0_5 border-b border-sky-950 mb-2_5 !text-[#00355f] !text-[1.6em] w-full js-full-width": t === "1",
    "font-medium mb-0 mt-[42px] !text-[#00355f] !text-[1.40625em]": t === "2",
    "font-bold mb-0 mt-[24px] !text-[#00355f] !text-[1.0375em]": t === "3",
    "font-bold mb-0 mt-0 !text-[0.875em]": t === "4",
    "text-gray-800 font-bold mb-1 mt-0 uppercase pl-0 pr-10 pb-2.5 pt-5": t === "5"
  }), n = p[parseInt(t, 10)];
  return /* @__PURE__ */ s.jsx(
    n,
    {
      id: e,
      className: `${m} ${o || ""}`,
      "data-fullwidthElement": "reportHeading",
      children: u(r)
    }
  );
};
export {
  E as default
};
//# sourceMappingURL=index.es2.js.map
